module.exports = __webpack_public_path__ + "img/truck-flatbed.161654e3.svg";